"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = void 0;
exports.spacing = [
    0,
    4,
    8,
    16,
    24,
    32,
    40,
    48,
    56,
    64,
    72,
    80,
    88,
    96,
    104,
    112,
    120,
    128,
    136,
    144,
    152, // 20
];
//# sourceMappingURL=spacing.js.map